module.exports = __webpack_public_path__ + "static/media/logo_weatherplus_new.f0400df6.jpg";